import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Select} from '@ngxs/store';
import {combineLatest, Observable} from 'rxjs';
import {AuthState} from '../../state/auth.state';
import {AnimationOptions} from 'ngx-lottie';
import {map} from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  @Select(AuthState.isAuthenticated)
  public authenticated$: Observable<boolean>;

  @Select(AuthState.modules)
  public modules$: Observable<string[]>;

  public options: AnimationOptions = {
    path: 'assets/lottie/app_loading.json',
  };

  constructor() {
  }

  ngOnInit(): void {
  }

  isLoadingIndicator$(): Observable<boolean> {
    return combineLatest([this.authenticated$, this.modules$]).pipe(map(value => {
      return !value[0] || value[1].length === 0;
    }));
  }

}
